import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';

function SubAdminSystemRestore(props) {
    const msg_update = useRef(null)
    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    const [message_log, setMessage_Log] = useState([])
    const [restore_status, setRestore_status] = useState(false)

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(message) {

    }

    useEffect(() => {
        msg_update.current = "-"
        //api_get_status();
        return () => {
            setMessage_Log([]);
        }
    }, []);


    useEffect(() => {
        const timerId = setInterval(() => {
            //api_get_status();
        }, 1000);
        return () => clearInterval(timerId);
    }, []);

    async function api_get_status() {
        const formData = new FormData()
        formData.append('update', msg_update.current)
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/restore/message", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    if (response.data.data !== null && response.data.data !== undefined) {
                        setMessage_Log(response.data.data)
                        msg_update.current = response.data.update
                    }
                    if (response.data.active !== undefined) {
                        setRestore_status(response.data.active)
                    }
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                });
            });
    }

    async function api_start_restore() {
        const formData = new FormData();
        formData.append('password', "ChowCP2024")

        setmodal_load({ enable: true, message: "Sending start command." })
        await sleep(500)

        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/restore/start", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Your start command has been sent to API.",
                        enable: true
                    });
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                });
            });
    }

    async function api_stop() {
        const formData = new FormData();

        setmodal_load({ enable: true, message: "Sending stop command." })
        await sleep(500)

        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/restore/stop", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Your stop command has been sent to API.",
                        enable: true
                    });
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                });
            });
    }

    async function api_clear_log() {
        const formData = new FormData();

        setmodal_load({ enable: true, message: "Sending clear log command." })
        await sleep(500)

        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/restore/clearlog", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Message log command has been cleared.",
                        enable: true
                    });
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                });
            });
    }

    async function api_reboot() {
        setmodal_load({ enable: true, message: "Rebooting application....." })
        await sleep(500)

        const formData = new FormData()
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/app/reboot", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Your application has been recieved reboot command.",
                        enable: true
                    });
                } else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    async function api_start_backup() {
        setmodal_load({ enable: true, message: "Backup configuration....." })
        await sleep(500)

        const formData = new FormData()
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/backup/multi", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Your configuration has been backup to server.",
                        enable: true
                    });
                } else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }


    async function api_init_hour() {
        setmodal_load({ enable: true, message: "initial hourly....." })
        await sleep(500)

        const formData = new FormData()
        formData.append('datex', '2026-07-21 03:00:00')
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/reference/init/hour", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Completed.",
                        enable: true
                    });
                } else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    async function api_init_day() {
        setmodal_load({ enable: true, message: "initial daily....." })
        await sleep(500)

        const formData = new FormData()
        formData.append('datex', '2026-06-27 03:00:00')
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/reference/init/day", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Completed.",
                        enable: true
                    });
                } else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    async function api_recal_peak() {
        setmodal_load({ enable: true, message: "Recal peak....." })
        await sleep(500)

        const formData = new FormData()
        formData.append('date_start', '2025-01-01')
        formData.append('date_stop', '2026-07-21')
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/reference/recal/peak", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Completed.",
                        enable: true
                    });
                } else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

        async function api_recal_hourly_calc() {
        setmodal_load({ enable: true, message: "Recal hourly....." })
        await sleep(500)

        const formData = new FormData()
        formData.append('date_start', '2026-08-01 00:00:00')
        formData.append('date_stop', '2026-10-02 00:00:00')
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/reference/recal/hourlycalc", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Completed.",
                        enable: true
                    });
                } else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="fas fa-coins"></i> Backup & Restore</h4>
                                    <p className="mb-3">Restore your data from center data storage</p>
                                </div>
                                <div>
                                    {BackCenter()}
                                </div>
                            </div>
                            <hr className="new-section-xs mt-0 mb-2" />
                            <h6>Common Restore Command</h6>
                            <div className="d-flex justify-content-start gap-3 mt-1 mb-3">
                                <button className="btn btn-success btn-sm" onClick={() => { api_get_status() }}><i className="fas fa-sync-alt"></i> Refresh</button>
                                <button className="btn btn-danger btn-sm" type="button" onClick={() => { api_stop() }}><i className="fas fa-square"></i> Stop Restore</button>
                                <button className="btn btn-danger btn-sm" type="button" onClick={() => { api_reboot() }}><i className="fas fa-power-off"></i> Reboot Service</button>
                                <button className="btn btn-warning btn-sm" type="button" onClick={() => { api_clear_log() }}><i className="far fa-trash-alt"></i> Clear Message Log</button>
                            </div>
                            <h6>Restore Configuration Command</h6>
                            <div className="d-flex justify-content-start gap-3 mt-1 mb-3">
                                <button className="btn btn-info btn-sm" type="button" onClick={() => { api_start_restore() }}><i className="fas fa-coins"></i> Restore Configuration</button>
                                <button className="btn btn-info btn-sm" type="button" onClick={() => { api_start_backup() }}><i className="fas fa-coins"></i> Backup Configuration</button>
                            </div>

                            <h6>Init Peak Command</h6>
                            <div className="d-flex justify-content-start gap-3 mt-1 mb-3">
                                <button className="btn btn-info btn-sm" type="button" onClick={() => { api_init_hour() }}><i className="fas fa-coins"></i> Init Hour</button>
                                <button className="btn btn-info btn-sm" type="button" onClick={() => { api_init_day() }}><i className="fas fa-coins"></i> Init Day</button>
                                <button className="btn btn-info btn-sm" type="button" onClick={() => { api_recal_peak() }}><i className="fas fa-coins"></i> Recal Peak</button>
                            </div>

                             <h6>Calc Command</h6>
                            <div className="d-flex justify-content-start gap-3 mt-1 mb-3">
                                <button className="btn btn-info btn-sm" type="button" onClick={() => { api_recal_hourly_calc() }}><i className="fas fa-coins"></i> Calc Hour</button>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3 mb-1 mb-md-1">
                        <h5>Event Message Log</h5>
                        <h6>Status : {restore_status === true ? "Processing" : "Stop"}</h6>
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered text-nowrap" >
                                <thead>
                                    <tr className="admintable-header">
                                        <th className="id-fixwidth">Message Log</th>
                                    </tr>
                                </thead>
                                <tbody id="tablebody">
                                    {
                                        message_log.map((message, index) => (
                                            <tr key={index}>
                                                <td className='font-sarabun'>{message}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>

                        </div>
                    </div>

                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}

export default SubAdminSystemRestore